<template>
  <v-row no-gutters>
    <template v-if="eType==='LIGHT'">
      <v-col class="pl-1 pr-2">
        <v-select filled v-model="onV" :items="switchItems" 
        :hide-details="hideDetails" single-line :label="$t('type.SWITCH')"></v-select>
      </v-col>
      <v-col>
        <v-text-field filled :hide-details="hideDetails" v-model="brightness" :rules="rulesThreshold" :label="$t('unit.%')"></v-text-field>
      </v-col>
    </template>
    <template v-else-if="eType==='SWITCH'">
      <v-col cols="6" offset="6" class="pl-1">
        <v-select filled v-model="onV" :items="switchItems"
        :hide-details="hideDetails" single-line :label="$t('type.SWITCH')"></v-select>
      </v-col>
    </template>
    <template v-else-if="eType==='CURTAIN'">
      <v-col class="pl-1 pr-2">
        <v-select filled v-model="openDirection" :items="openDirectionItems" 
        :hide-details="hideDetails" :label="$t('fan.direction')"></v-select>
      </v-col>
      <v-col>
        <v-text-field filled :hide-details="hideDetails" v-model="openPercent" :rules="rulesThreshold" :label="$t('unit.%')"></v-text-field>
      </v-col>
    </template>
    <template v-else-if="eType==='FAN'">
      <v-col class="pr-2">
        <v-select filled v-model="onV" :items="fanSwitchItems" 
        :hide-details="hideDetails" single-line :label="$t('type.SWITCH')"></v-select>
      </v-col>
      <v-col class="pr-2">
        <v-select filled v-model="fanDirection" :items="fanDirectionItems" 
        :hide-details="hideDetails" :label="$t('fan.direction')"></v-select>
      </v-col>
      <v-col>
        <v-select filled v-model="fanSpeed" :items="fanSpeedItems" 
        :hide-details="hideDetails" :label="$t('fan.speed')"></v-select>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'EndpointValueSelector',
  props: {
    value: {
      type: Object
    },
    'hideDetails': {
      type: Boolean,
      default: true
    },
    eType: {
      type: String
    }
  },
  data() {
    return {
      rulesThreshold: [
        v => (parseInt(v) >= 0 && parseInt(v) <= 100) || this.$t('configurations.threadhold_between', {
          from: 0,
          to: 100
        })
      ],
      switchItems: [{
        text: this.$t('switch.ON'),
        value: 1
      }, {
        text: this.$t('switch.OFF'),
        value: 0
      }],
      fanSwitchItems: [{
        text: this.$t('fan.start'),
        value: 1
      }, {
        text: this.$t('fan.stop'),
        value: 0
      }],
      fanDirectionItems: [{
        text: this.$t('fan.forward'),
        value: 1
      }, {
        text: this.$t('fan.backward'),
        value: 2
      }],
      fanSpeedItems: [{
        text: this.$t('fan.SILENT'),
        value: 1
      }, {
        text: this.$t('fan.LOW'),
        value: 2
      }, {
        text: this.$t('fan.MEDIUM'),
        value: 3
      }, {
        text: this.$t('fan.HIGH'),
        value: 4
      }],
      openDirectionItems: [{
        text: this.$t('curtain.up'),
        value: 1
      }, {
        text: this.$t('curtain.down'),
        value: 2
      }, {
        text: this.$t('curtain.left'),
        value: 3
      }, {
        text: this.$t('curtain.right'),
        value: 4
      },
      {
        text: this.$t('curtain.in'),
        value: 5
      },
      {
        text: this.$t('curtain.out'),
        value: 6
      }],
      onV: (this.value || {}).on || 0,
      brightness: (this.value || {}).brightness || 0,
      openDirection: (this.value || {}).openDirection || 1,
      openPercent: (this.value || {}).openPercent || 0,
      fanDirection: (this.value || {}).fanDirection || 1,
      fanSpeed: (this.value || {}).fanSpeed || 1
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', val);
      }
    }
  },
  watch: {
    onV() {
      switch(this.eType) {
        case 'SWITCH':
          return this.$emit('input', {on: this.onV});
        case 'LIGHT':
          return this.$emit('input', {on: this.onV, brightness: parseInt(this.brightness)});
        case 'FAN':
          return this.$emit('input', {on: this.onV, fanDirection: this.fanDirection, fanSpeed: this.fanSpeed});
      }
    },
    brightness() {
      if (this.eType == 'LIGHT') return this.$emit('input', {on: this.onV, brightness: parseInt(this.brightness)});
    },
    fanDirection() {
      if (this.eType == 'FAN') return this.$emit('input', {on: this.onV, fanDirection: this.fanDirection, fanSpeed: this.fanSpeed});
    },
    fanSpeed() {
      if (this.eType == 'FAN') return this.$emit('input', {on: this.onV, fanDirection: this.fanDirection, fanSpeed: this.fanSpeed});
    },
    openDirection() {
      if (this.eType == 'CURTAIN') return this.$emit('input', {openDirection: this.openDirection, openPercent: parseInt(this.openPercent)});
    },
    openPercent() {
      if (this.eType == 'CURTAIN') return this.$emit('input', {openDirection: this.openDirection, openPercent: parseInt(this.openPercent)});
    }
  },
  mounted() {
    switch(this.eType) {
      case 'SWITCH':
        this.$emit('input', {on: this.onV});
        break
      case 'LIGHT':
        this.$emit('input', {on: this.onV, brightness: parseInt(this.brightness)});
        break
      case 'FAN':
        this.$emit('input', {on: this.onV, fanDirection: this.fanDirection, fanSpeed: this.fanSpeed});
        break
      case 'CURTAIN':
        this.$emit('input', {openDirection: this.openDirection, openPercent: this.openPercent});
        break
    }
  }
}
</script>